module.exports = __webpack_public_path__ + "src/img/bin.8d89a3ab.svg";